import React from 'react';
import cl from 'classnames';
import s from './Spinner.module.css';

export default function Spinner({style}) {
  return (
    <div className={cl(s.Spinner, s.Center)} style={style}>
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
      <div className={s.SpinnerBlade} />
    </div>
  );
}
